<template>
  <div class="product">
    <div class="banner">
      <div class="swiper-container bot">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide slide"
            v-for="(item, index) in latestNews"
            :key="index"
            @click="getlink(item.id)"
          >
            <img :src="item.photo && $imgurl + item.photo.url" alt="" />
            <div class="sam_box">
              <div class="txt">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="list">
      <ul>
        <li
          v-for="(item, index) in list.slice(0,3)"
          :key="index"
          @click="getlink(item.id)"
        >
          <p>{{ item.title }}</p>
          <p>{{ item.timeline }}</p>
          <p v-html="item.content" ref="dom_p"></p>
        </li>
      </ul>
      <div class="btn" @click="gettolink(ctype, cid)">查看更多</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      pageNo: 1,
      pageSize: 6,
      //轮播数据
      latestNews: [],
      //数据列表
      list: [],
      cid: 0,
      ctype: 0,
    };
  },
  methods: {
    //数据请求
    getData() {
      this.$fetch({
        url: "index.php/news/cpdt",
        type: "post",
        data: this.$qs.stringify({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }),
      }).then((res) => {
        this.latestNews = res.data.latestNews;
        this.list = res.data.list;
        this.cid = res.data.cid;
        this.ctype = res.data.ctype;
        this.$nextTick(() => {
          this.swiper();
          this.getx();
        });
      });
    },
    //轮播
    swiper() {
      new Swiper(".swiper-container", {
        loop: true,
        // 如果需要分页器
        pagination: ".swiper-pagination",
        // 如果需要前进后退按钮
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        //如果需要自动切换海报
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        autoplay : 3000,
      });
    },
    //跳详情
    getlink(id) {
      this.$router.push({
        path: "/newsview",
        query: {
          id,
          crems: JSON.stringify({ title: "产品动态" }),
        },
      });
    },
    //跳列表
    gettolink(ctype, cid) {
      this.$router.push({
        path: "/newslist",
        query: {
          ctype: ctype,
          cid: cid,
          crems: JSON.stringify({ title: "产品动态", path: "/news/product" }),
        },
      });
    },
    //p元素
    getx() {
      var stp = this.$refs.dom_p;
      for (var i = 0; i < stp.length; i++) {
        stp[i].innerText = stp[i].innerText.slice(0, 50) + '...';
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.product .swiper-pagination-bullet {
  width: 28px !important;
  height: 10px !important;
  background: #b7b7b7 !important;
  border-radius: 8px !important;
  margin-right: 6px;
}
.product .swiper-pagination-bullet-active {
  width: 48px !important;
  height: 10px !important;
  background: #396aff !important;
  border-radius: 8px !important;
}
</style>
<style scoped>
.banner {
  width: 750px;
  padding: 30px 0 106px;
  background: #f0f2f5;
  position: relative;
}
.swiper-pagination {
  left: 43%;
  bottom: 20px;
  transform: translateY(-50%);
  margin-top: 44px;
}

.banner .bot {
  width: 690px;
  height: 460px;
}
.banner .slide {
  position: relative;
}
.banner .swiper-slide img {
  width: 690px;
  height: 460px;
}
.banner .swiper-slide .sam_box {
  width: 100%;
  height: 115px;
  background: linear-gradient(
    327deg,
    rgba(57, 106, 255, 0.33) 0%,
    #396aff 100%
  );
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 30px;
}
.banner .sam_box .txt {
  width: 627px;
  height: 24px;
  font-size: 28px;
  color: #ffffff;
  line-height: 24px;
  margin-right: 30px;
}
.list {
  width: 750px;
  background: #ebeef0;
  padding-bottom: 83px;
}
.list ul {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.list ul li {
  width: 690px;
  height: 269px;
  background: #ffffff;
  margin-bottom: 30px;
  padding: 0 33px;
}
.list .btn {
  width: 208px;
  height: 72px;
  border: 1px solid #396aff;
  color: #396aff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto 0;
  font-size: 24px;
}
.list ul li p:nth-child(1) {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  margin-top: 25px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list ul li p:nth-child(2) {
  font-size: 24px;
  font-weight: 400;
  color: #999999;
  line-height: 33px;
  margin: 8px 0 30px 0px;
}
.list ul li p:nth-child(3) {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  /* display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden; */
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>